import React from "react";

import { Tabs } from "../../../../components";
import { ButtonLinkStyled } from "../../../../components/common/Buttons/Button.Style";

import { ReactComponent as PaperIcon } from "../../../../assets/images/icons/paper-icon.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/images/icons/zeppelin-download-icon.svg";
import { ReactComponent as WorldIcon } from "../../../../assets/images/icons/world-icon.svg";
import { ReactComponent as AgreementIcon } from "../../../../assets/images/icons/agreement-icon.svg";

import * as S from "./TransparencySection.style";

const transparencyList = [
  {
    id: 1,
    title: "Ética e Conformidade",
    icon: AgreementIcon,
    links: [
      {
        label:
          "Relatório de Transparência Salarial e de Critérios Remuneratórios",
        href:
          // eslint-disable-next-line max-len
          "https://nam10.safelinks.protection.outlook.com/?url=https%3A%2F%2Fstatic.cnpbrasil.com.br%2FAreaAberta%2FRelatorios%2FRelat%25C3%25B3rio%2520de%2520Transpar%25C3%25AAncia%2520e%2520Igualdade%2520Salarial%2520de%2520Mulheres%2520e%2520Homens%25201.2024.pdf&data=05%7C02%7CPedro.Oliveira.Hyti%40cnpbrasil.com.br%7Cd10b3688b1f64f39dcc408ddcdd9bfc3%7Cf1f3b372308b4b7fa66b62bdcba897e4%7C0%7C0%7C638893057609029304%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=K27OodCrGY7ihjfQKl4Lhv664oLi6LbdN9RlPOHHrOA%3D&reserved=0",
      },
      {
        label: "Guia de Uso Aceitável",
        href:
          // eslint-disable-next-line max-len
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/GUIA%20SGI%20004%2001%20-%20Guia%20de%20Uso%20Aceit%C3%A1vel%20de%20Recursos%20Tecnol%C3%B3gicos.pdf?_ga=2.153060785.92447727.1667843332-542798228.1660054478",
      },
      {
        label: "Cartilha de Prevenção à Fraude",
        href:
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/CNP_CARTILHA_FRAUDE_0811.pdf?_ga=2.216509086.92447727.1667843332-542798228.1660054478",
      },
      {
        label:
          "Cartilha de Prevenção à Lavagem de Dinheiro e Combate ao Terrorismo",
        href:
          // eslint-disable-next-line max-len
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/CARTILHA_LAVAGEM_DINHEIRO%200811%20vs%20FINAL_%20INTERNET.pdf?_ga=2.216509086.92447727.1667843332-542798228.1660054478",
      },
      {
        label: "Código de Ética e Conduta",
        href:
          // eslint-disable-next-line max-len
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Code%20de%20conduite%20Groupe%20C@pEthic%20-%20Site%20institutionnel%20-%20anglais%20-%20avril%202022.pdf?_ga=2.176611757.92447727.1667843332-542798228.1660054478",
      },
      {
        label:
          "Código de Ética e Conduta dos Prestadores de Serviços e Parceiros de negócio",
        href:
          // eslint-disable-next-line max-len
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/CNP_21_C%C3%B3digo_de_%C3%89tica_Fornecedor.pdf?_ga=2.207677082.92447727.1667843332-542798228.1660054478",
      },
      {
        label: "Cartilha Anticorrupção",
        href:
          // eslint-disable-next-line max-len
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/CNP_CARTILHA_ANTI-CORRUPCAO_0811.pdf?_ga=2.174006315.92447727.1667843332-542798228.1660054478",
      },
      {
        label: "Política Anticorrupção",
        href:
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Política_Anticorrupcao-CSH.pdf",
      },
    ],
  },

  {
    id: 2,
    title: "Sustentabilidade",
    icon: WorldIcon,
    links: [
      {
        label: "Relatório de Sustentabilidade 2024",
        href:
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2024.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2023",
        href:
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2023.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2022",
        href:
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2022.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2021",
        href:
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2021.pdf",
      },
      {
        label: "Relatório de Sustentabilidade 2020",
        href:
          // eslint-disable-next-line max-len
          "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-Caixa-Seguradora-2020.pdf?utm_medium=canais-proprios&utm_source=area-aberta&utm_campaign=site-cnp&utm_term=ae378&utm_content=corporativo-relatorio-de-sustentabilidade-cs-2020",
      },
    ],
  },
  {
    id: 3,
    title: "Financeiro",
    icon: PaperIcon,
    links: [
      {
        label: "Balanço financeiro (Exercício 2024)",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/BalancoFinanceiro/balanco-financeiro-exercicio-2024.pdf",
      },
      {
        label: "Balanço financeiro (Exercício 2023)",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/BalancoFinanceiro/balanco-financeiro-exercicio-2023.pdf",
      },
      {
        label: "Balanço financeiro (Exercício 2022)",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/BalancoFinanceiro/balanco-financeiro-exercicio-2022.pdf",
      },
      {
        label: "Balanço financeiro (Exercício 2021)",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/BalancoFinanceiro/balanco-financeiro-exercicio-2021.pdf",
      },
      {
        label: "Balanço financeiro (Exercício 2020)",
        href:
          "https://cdn.caixaseguradora.com.br/AreaAberta/BalancoFinanceiro/balanco-financeiro-exercicio-2020.pdf",
      },
    ],
  },
];

export const TransparencySection = () => {
  return (
    <S.TransparencySectionContainer>
      <S.TransparencySectionContent className="container">
        <S.TransparencySectionHeader>
          <S.TransparencySectionTitle>Transparência</S.TransparencySectionTitle>

          <S.TransparencySectionDescription>
            Acreditamos que compartilhar nossos resultados de forma transparente
            e acessível é agir com responsabilidade e ética. Neste espaço, você
            encontra relatórios e balanços financeiros, nosso código de ética,
            as políticas de sustentabilidade e de anticorrupção, e muito mais.
            Confira!
          </S.TransparencySectionDescription>
        </S.TransparencySectionHeader>

        <Tabs
          variant="secondary"
          tabs={transparencyList.map((transparencyItem) => ({
            ...transparencyItem,
            content: (
              <S.TransparencyItemContainer>
                {transparencyItem?.icon ? (
                  <transparencyItem.icon
                    width={264}
                    className="transparencyImage"
                  />
                ) : null}

                <S.TransparencyItemList>
                  {Array.isArray(transparencyItem.links)
                    ? transparencyItem.links.map((linkItem, index) => (
                        <ButtonLinkStyled
                          as="a"
                          key={`${index}-link`}
                          href={linkItem.href}
                          target="_blank"
                        >
                          <DownloadIcon width={28} height={28} />
                          <span>{linkItem.label}</span>
                        </ButtonLinkStyled>
                      ))
                    : null}
                </S.TransparencyItemList>
              </S.TransparencyItemContainer>
            ),
          }))}
        />
      </S.TransparencySectionContent>
    </S.TransparencySectionContainer>
  );
};
